import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  LOCATION_ITEM_ADD: 'LOCATION_ITEM_ADD',
  LOCATION_ITEM_CLEAR: 'LOCATION_ITEM_CLEAR',
  LOCATION_ITEM_SET: 'LOCATION_ITEM_SET',
  LOCATION_ITEM_UPDATE: 'LOCATION_ITEM_UPDATE',

  LOCATION_PATCH_FAILURE: 'LOCATION_PATCH_FAILURE',
  LOCATION_PATCH_REQUEST: 'LOCATION_PATCH_REQUEST',
  LOCATION_PATCH_SUCCESS: 'LOCATION_PATCH_SUCCESS',

  LOCATION_PATCH_GEO_FAILURE: 'LOCATION_PATCH_GEO_FAILURE',
  LOCATION_PATCH_GEO_REQUEST: 'LOCATION_PATCH_GEO_REQUEST',
  LOCATION_PATCH_GEO_SUCCESS: 'LOCATION_PATCH_GEO_SUCCESS',

  LOCATIONS_CLEAR: 'LOCATIONS_CLEAR',

  LOCATIONS_GET_FAILURE: 'LOCATIONS_GET_FAILURE',
  LOCATIONS_GET_REQUEST: 'LOCATIONS_GET_REQUEST',
  LOCATIONS_GET_SUCCESS: 'LOCATIONS_GET_SUCCESS',

  LOCATIONS_POST_FAILURE: 'LOCATIONS_POST_FAILURE',
  LOCATIONS_POST_REQUEST: 'LOCATIONS_POST_REQUEST',
  LOCATIONS_POST_SUCCESS: 'LOCATIONS_POST_SUCCESS',

  LOCATIONS_MERGE: 'LOCATIONS_MERGE',
  LOCATIONS_SET: 'LOCATIONS_SET',
};

export const actionCreators = {
  clear: () => ({
    type: actionTypes.LOCATIONS_CLEAR,
  }),

  getRequest: () => ({
    type: actionTypes.LOCATIONS_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.LOCATIONS_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.LOCATIONS_GET_FAILURE,
  }),
  getSuccess: (locations: any) => ({
    type: actionTypes.LOCATIONS_GET_SUCCESS,
    payload: { locations },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.LOCATIONS_GET_FAILURE,
    error,
  }),

  itemAdd: () => ({
    type: actionTypes.LOCATION_ITEM_ADD,
  }),
  itemClear: () => ({
    type: actionTypes.LOCATION_ITEM_CLEAR,
  }),
  itemSet: (location: any) => ({
    type: actionTypes.LOCATION_ITEM_SET,
    payload: { location },
  }),
  itemUpdate: (location: any) => ({
    type: actionTypes.LOCATION_ITEM_UPDATE,
    payload: { location },
  }),

  patchRequest: (location: any) => ({
    type: actionTypes.LOCATION_PATCH_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.LOCATION_PATCH_SUCCESS,
    [ERROR_ACTION]: actionTypes.LOCATION_PATCH_FAILURE,
    payload: { location },
  }),
  patchSuccess: (location: any) => ({
    type: actionTypes.LOCATION_PATCH_SUCCESS,
    payload: { location },
  }),
  patchFailure: (error: Error) => ({
    type: actionTypes.LOCATION_PATCH_FAILURE,
    error,
  }),

  patchGeoRequest: (location: any) => ({
    type: actionTypes.LOCATION_PATCH_GEO_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.LOCATION_PATCH_GEO_SUCCESS,
    [ERROR_ACTION]: actionTypes.LOCATION_PATCH_GEO_FAILURE,
    payload: { location },
  }),
  patchGeoSuccess: (location: any) => ({
    type: actionTypes.LOCATION_PATCH_GEO_SUCCESS,
    payload: { location },
  }),
  patchGeoFailure: (error: Error) => ({
    type: actionTypes.LOCATION_PATCH_GEO_FAILURE,
    error,
  }),

  postRequest: (locations: Array<any>) => ({
    type: actionTypes.LOCATIONS_POST_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.LOCATIONS_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.LOCATIONS_POST_FAILURE,
    payload: { locations },
  }),
  postSuccess: (locations: Array<any>) => ({
    type: actionTypes.LOCATIONS_POST_SUCCESS,
    payload: { locations },
  }),
  postFailure: (error: Error) => ({
    type: actionTypes.LOCATIONS_POST_FAILURE,
    error,
  }),

  merge: (locations: Array<any>) => ({
    type: actionTypes.LOCATIONS_MERGE,
    payload: { locations },
  }),
  set: (locations: Array<any>) => ({
    type: actionTypes.LOCATIONS_SET,
    payload: { locations },
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
